import { Divider, ListItem, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface TableServiceMenuProps {
  visibility?: {
    ricercaRegistro: boolean;
    ricercaTipoPratica: boolean;
    ricercaTipoOperazione: boolean;
    ricercaResponsabile: boolean;
    ricercaMetrica: boolean;
  };
  onClick: (event: MouseEvent<HTMLElement>) => void;
  onClose: (event: MouseEvent) => void;
  submenuAnchor: Element | null;
  isSubmenuVisible: boolean;
}

const TableServiceMenu = ({
  visibility = {
    ricercaRegistro: true,
    ricercaTipoPratica: true,
    ricercaTipoOperazione: true,
    ricercaResponsabile: true,
    ricercaMetrica: true,
  },
  onClick,
  onClose,
  isSubmenuVisible,
  submenuAnchor,
}: TableServiceMenuProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <ListItem onClick={onClick}>
        <ListItemText primary="Tabelle di servizio" />
      </ListItem>
      <Menu
        id="table-service-menu"
        anchorEl={submenuAnchor}
        open={isSubmenuVisible}
        onClose={onClose}
        PaperProps={{
          style: {
            width: '30ch',
          },
        }}
      >
        {visibility.ricercaTipoPratica
          ? [
              <MenuItem
                key="ricercaTipoPratica-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/ricerca-tipo-pratica');
                }}
              >
                <Typography variant="inherit">Gestione Tipo Pratica</Typography>
              </MenuItem>,
              <Divider
                key="ricercaTipoPratica-divider"
                hidden={
                  !visibility.ricercaTipoOperazione &&
                  !visibility.ricercaRegistro &&
                  !visibility.ricercaResponsabile &&
                  !visibility.ricercaMetrica
                }
              />,
            ]
          : undefined}
        {visibility.ricercaTipoOperazione
          ? [
              <MenuItem
                key="ricercaTipoOperazione-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/ricerca-tipo-operazione');
                }}
              >
                <Typography variant="inherit">Gestione Tipo Operazione</Typography>
              </MenuItem>,
              <Divider
                key="ricercaTipoOperazione-divider"
                hidden={
                  !visibility.ricercaRegistro &&
                  !visibility.ricercaResponsabile &&
                  !visibility.ricercaMetrica
                }
              />,
            ]
          : undefined}
        {visibility.ricercaRegistro
          ? [
              <MenuItem
                key="ricercaRegistro-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/ricerca-registro');
                }}
              >
                <Typography variant="inherit">Gestione Registro</Typography>
              </MenuItem>,
              <Divider
                key="ricercaRegistro-divider"
                hidden={!visibility.ricercaResponsabile && !visibility.ricercaMetrica}
              />,
            ]
          : undefined}
        {visibility.ricercaResponsabile
          ? [
              <MenuItem
                key="ricercaResponsabile-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/ricerca-responsabile');
                }}
              >
                <Typography variant="inherit">Gestione Responsabile</Typography>
              </MenuItem>,
              <Divider key="ricercaResponsabile-divider" hidden={!visibility.ricercaMetrica} />,
            ]
          : undefined}
        {visibility.ricercaMetrica
          ? [
              <MenuItem
                key="ricercaMetrica-menu-item"
                onClick={(event) => {
                  onClose(event);
                  navigate('/pratiche/ricerca-metrica');
                }}
              >
                <Typography variant="inherit">Gestione Metriche</Typography>
              </MenuItem>,
            ]
          : undefined}
      </Menu>
    </Fragment>
  );
};

TableServiceMenu.displayName = 'Table Service Menu';

export default TableServiceMenu;
